import { render, staticRenderFns } from "./PasswordGate.vue?vue&type=template&id=712042ad"
import script from "./PasswordGate.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordGate.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports